import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableSortLabel } from "@mui/material";
import OverviewTablePagination from "src/scenes/overview/overview-components/details-tables/overview-table-pagination";
import { format } from "date-fns";

const columns = [
    { id: "issueKey", label: "Issue", minWidth: 120, isSortable: true },
    { id: "doneAt", label: "Done At", minWidth: 120, isSortable: true },
];

const ThroughputPmTable = ({ data }) => {
    if (!data) return null;
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [sortOrder, setSortOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("");
    const createData = (issueKey, doneAt) => {
        return { issueKey, doneAt };
    };

    const rows = data.map((issue) => createData(issue.issue_key, issue.done_at));

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && sortOrder === "asc";
        setSortOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const stableSort = (array, comparator) => {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const orderResult = comparator(a[0], b[0]);
            if (orderResult !== 0) return orderResult;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const descendingComparator = (a, b) => {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    };

    const getComparator = () => {
        return sortOrder === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };

    const sortedRows = stableSort(rows, getComparator(sortOrder, orderBy));

    const needsPagination = rowsPerPage < rows.length;

    return (
        <Paper sx={{ width: "100%", overflow: "hidden", marginTop: "8px", boxShadow: "none" }}>
            <TableContainer>
                <Table stickyHeader size="small" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth, fontSize: "12px" }}
                                >
                                    {column.isSortable ? (
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? sortOrder : "asc"}
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    ) : (
                                        column.label
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedRows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.id === "doneAt" && value) {
                                                value = format(new Date(value), "dd/MM/yyyy");
                                            }
                                            return (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{
                                                        fontSize: "12px",
                                                        backgroundColor: "#333333",
                                                    }}
                                                >
                                                    {column.format && typeof value === "number"
                                                        ? column.format(value)
                                                        : value}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            {needsPagination &&
                OverviewTablePagination({ rows, rowsPerPage, page, setPage, setRowsPerPage })}
        </Paper>
    );
};

export default ThroughputPmTable;
